import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "splitCC" //split Camel Case
})
export class SplitPipe implements PipeTransform {
  transform(value: string): string {
    if (undefined !== value) {
      let newStr = value
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
      return newStr;
    }
    return "";
  }
}

@Pipe({
  name: 'camlCase'
})
export class CamlCasePipe implements PipeTransform {
    transform(val: any, args?: any): any {
        return JSON.parse(JSON.stringify(val, function (key, value) {
            if (value && typeof value === 'object') {
                var replacement = {};
                for (var k in value) {
                    if (Object.hasOwnProperty.call(value, k)) {
                    replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                    }
                }
                if(Array.isArray(value))
                {
                    var replacementArr = [];
                    for (var k in replacement) {
                        replacementArr.push(replacement[k]);
                    }
                    return replacementArr;
                }
                return replacement;
            }
            return value;
        }));
    }
}

@Pipe({
    name: 'PascalCase'
  })
  export class PascalCasePipe implements PipeTransform {
      transform(val: any, args?: any): any {
          return JSON.parse(JSON.stringify(val, function (key, value) {
              if (value && typeof value === 'object') {
                  var replacement = {};
                  for (var k in value) {
                      if (Object.hasOwnProperty.call(value, k)) {
                      replacement[k && k.charAt(0).toUpperCase() + k.substring(1)] = value[k];
                      }
                  }
                  if(Array.isArray(value))
                  {
                      var replacementArr = [];
                      for (var k in replacement) {
                          replacementArr.push(replacement[k]);
                      }
                      return replacementArr;
                  }
                  return replacement;
              }
              return value;
          }));
      }
  }